import { css } from '@linaria/atomic';
import { Link } from '@tanstack/react-router';
import { NakedButton } from '../../naked/naked-button.component';
import { Text } from '../text/text.component';

const BREADCRUMB_LINK = css`
  text-decoration: none;
`;

export type BreadcrumbPathProps = {
  to?: string;
  label: string;
  onClick?: () => void;
};

export const BreadcrumbPath = ({ to, label, onClick }: BreadcrumbPathProps) => {
  if (onClick) {
    return (
      <Text as={NakedButton} color='light' onClick={onClick} data-trackingid={`shrd-nav-breadcrumb-${label}`}>
        {label}
      </Text>
    );
  } else if (to) {
    return (
      <Text
        //@ts-ignore - TS doesn't pick up the to prop since we are rendering as a link
        to={to}
        color='light'
        as={Link}
        data-trackingid={`shrd-nav-breadcrumb-${label}`}
        className={BREADCRUMB_LINK}
      >
        {label}
      </Text>
    );
  }
  return <Text color='light'>{label}</Text>;
};
